import { Box, styled, Typography } from '@mui/material';
import type { Breakpoint } from '@mui/system';

import { getStyledOptions } from '/styles/helpers/getStyledOptions';
import type { IWithCSS } from '/common/models';

type ITitleWrapperProps = { $maxWidth: number | Breakpoint; $offset: number; $css?: IWithCSS };

export const TitleWrapper = styled(Box, getStyledOptions<ITitleWrapperProps>())<ITitleWrapperProps>`
  display: flex;
  justify-content: space-between;
  align-items: center;
  overflow: hidden;
  text-overflow: ellipsis;
  width: 100%;

  max-width: ${({ theme, $maxWidth, $offset }) =>
    typeof $maxWidth === 'number' ? `${$maxWidth - $offset}px` : `${theme.breakpoints.values[$maxWidth] - $offset}px`};

  ${({ $css }) => $css};
`;

export const Title = styled(Typography)<{ $css?: IWithCSS }>`
  ${({ $css }) => $css};
`;
